export default function ToolTip({ children, text, direction = "top" }) {
    const positionClasses =
      direction === "top"
        ? "bottom-full mb-2"
        : "top-full mt-2";
  
    return (
      <div className="relative group inline-block">
        {children}
  
        <div
          className={`absolute left-1/2 -translate-x-1/2 ${positionClasses} w-max max-w-xs bg-white border-2 border-gray-200 rounded-xl shadow-lg p-3 text-sm text-gray-600 opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 z-50`}
        >
          {text}
        </div>
      </div>
    );
  }
  